import { render, staticRenderFns } from "./ScheduleArea.vue?vue&type=template&id=4be09ac6&"
import script from "./ScheduleArea.vue?vue&type=script&lang=ts&"
export * from "./ScheduleArea.vue?vue&type=script&lang=ts&"
import style0 from "./ScheduleArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports